export default {
    "success": true,
    "data": {
        "memes": [
            {
                "id": "181913649",
                "name": "Timiket",
                "url": "https://pbs.twimg.com/media/DLAgIe-UQAEQTZI.jpg",
                "width": 1200,
                "height": 1200,
                "box_count": 2
            },
            {
                "id": "87743020",
                "name": "Ketera",
                "url": "https://bulletin.hds.harvard.edu/files/2020/06/MAIN_TabotSt.Mary_101.r1.jpg",
                "width": 1200,
                "height": 1200,
                "box_count": 3
            },
            {
                "id": "112126428",
                "name": "Program",
                "url": "http://lh3.googleusercontent.com/-_hvPFVbBP4CoWGxLikB4-oil8KNu1AozmCJVypeIvv60YdEM9CCX8oiOohDsU4-Txkg1SVtfVD3Lg3i-sr0LtM=s900",
                "width": 1200,
                "height": 1200,
                "box_count": 3
            },
            
            {
                "id": "247375501",
                "name": "Buff Doge vs. Cheems",
                "url": "https://www.ethiosports.com/wp-content/uploads/2014/09/Gishen-Mariam-Monastery.jpg",
                "width": 937,
                "height": 720,
                "box_count": 4
            },
            {
                "id": "129242436",
                "name": "Change My Mind",
                "url": "http://msmedhanealem.org/uploads/1/1/5/9/115956753/20171203-130225_orig.jpg",
                "width": 1200,
                "height": 1200,
                "box_count": 2
            },
            {
                "id": "124822590",
                "name": "Left Exit 12 Off Ramp",
                "url": "https://wp.en.aleteia.org/wp-content/uploads/sites/2/2020/01/web3-ethiopian-epiphany-tabot-priest-shutterstock_1228936375.jpg",
                "width": 1200,
                "height": 1200,
                "box_count": 3
            },
            {
                "id": "181913649",
                "name": "Drake Hotline Bling",
                "url": "https://res.cloudinary.com/graham-media-group/image/fetch/f_auto/q_auto/c_scale,w_400/https://arc-anglerfish-arc2-prod-gmg.s3.amazonaws.com/public/FXWI44257BFZ3OVS4U6AYIF2ZQ.jpg?_a=ATAK9AA0",
                "width": 1200,
                "height": 1200,
                "box_count": 2
            },
        ]
    }
}